module.exports = __webpack_public_path__ + "img/3.aaeb5ee8.png";